import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=d5f4d5a8&"
import script from "./page7.vue?vue&type=script&lang=js&"
export * from "./page7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports